import { render, staticRenderFns } from "./ProductSizeChart.vue?vue&type=template&id=5775e5f4&scoped=true"
import script from "./ProductSizeChart.vue?vue&type=script&lang=js"
export * from "./ProductSizeChart.vue?vue&type=script&lang=js"
import style0 from "./ProductSizeChart.vue?vue&type=style&index=0&id=5775e5f4&prod&lang=css"
import style1 from "./ProductSizeChart.vue?vue&type=style&index=1&id=5775e5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5775e5f4",
  null
  
)

export default component.exports